import { useEffect } from 'react';
import { useAuth } from '@/hooks/use-auth';
import { notificationStream } from '@/services/notification-stream';
import {
  ensureNotificationPermission,
  initNotificationAudioUnlock,
  showNotification,
} from '@/lib/notification-display';

export function useNotificationStream() {
  const { session, ready } = useAuth();
  const authenticated = ready && session?.authenticated === true;

  // Keyed on the session OBJECT, not just the authenticated flag. The stream gives up after
  // repeated authorization failures, and the auth layer has a branch that re-validates a 401 and
  // finds the session still healthy — that path calls setSession with a fresh object but leaves
  // `authenticated` true. Depending on the flag alone, this effect would never re-run and the
  // stream would stay dead for the life of the tab; depending on the object re-opens it.
  useEffect(() => {
    if (!authenticated) return;

    initNotificationAudioUnlock();
    void ensureNotificationPermission();
    void notificationStream.open();
    const unsubscribe = notificationStream.subscribe(showNotification);

    return () => {
      unsubscribe();
      notificationStream.close();
    };
  }, [authenticated, session]);
}
